import { Action } from "domain/aangifte";
import { rubriekenFp, rubriekFp } from "domain/rubriek";
import { option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { RubriekReducer } from "../rubriekenReducer";

const isLimitedTo = (parentCode: string) => (code: string) => (rubrieken: RubriekReducer) => {
  return pipe(
    option.Do,
    option.bind("parent", () => pipe(rubrieken, rubriekenFp.lookupValue<number>(parentCode))),
    option.bind("rubriek", () => pipe(rubrieken, rubriekenFp.lookupValue<number>(code))),
    option.map(({ parent, rubriek }) => Math.min(parent, rubriek)),
    option.fold(
      () => pipe(rubrieken, rubriekenFp.modifyAt(code, rubriekFp.clearValue)),
      (value) => pipe(rubrieken, rubriekenFp.modifyAt(code, rubriekFp.modifyAt("value", value)))
    ),
    option.getOrElse(() => rubrieken)
  );
};

export const runGezinsLasteRules = (action: Action) => (rubrieken: RubriekReducer): RubriekReducer => {
  switch (action.type) {
    case "UPDATE_RUBRIEK_VALUE":
      return pipe(
        rubrieken,
        // Aantal kinderen die fiscaal volledig te uwen laste zijn
        pipe("1031", isLimitedTo("1030")),
        pipe("1038", isLimitedTo("1030")),
        pipe("1039", isLimitedTo("1031")),
        pipe("1039", isLimitedTo("1038")),

        // Aantal kinderen die fiscaal te uwen laste zijn, maar voor wie de helft van het belastingvoordeel moet worden toegekend
        // aan de andere ouder door de gelijkmatig verdeelde huisvesting van de kinderen
        pipe("1035", isLimitedTo("1034")),
        pipe("1054", isLimitedTo("1034")),
        pipe("1055", isLimitedTo("1035")),
        pipe("1055", isLimitedTo("1054")),

        // Aantal kinderen die fiscaal ten laste zijn van de andere ouder,
        // maar voor wie de helft van het belastingvoordeel aan u moet worden toegekend door de gelijkmatig verdeelde huisvesting van de kinderen
        pipe("1037", isLimitedTo("1036")),
        pipe("1058", isLimitedTo("1036")),
        pipe("1059", isLimitedTo("1037")),
        pipe("1059", isLimitedTo("1058")),

        // Aantal ouders, grootouders, overgrootouders, broers en zusters van 65 jaar of ouder die fiscaal te uwen laste zijn
        pipe("1029", isLimitedTo("1027")),
        pipe("1044", isLimitedTo("1043")),

        // Aantal andere personen die fiscaal te uwen laste zijn (noch uzelf, noch uw echtgenoot, noch uw samenwonende partner meetellen!)
        pipe("1033", isLimitedTo("1032"))
      );
    default:
      return rubrieken;
  }
};
